import React, { Component } from 'react';
import {
	ResponsiveContainer, Tooltip, Legend,
	PieChart, Pie, Cell
} from 'recharts';
import BlockUi from 'react-block-ui';
import chartUtils, { COLORS } from '../utils';
import { withTranslation } from 'react-i18next';

class LessonPaymentsByPaymentMethod extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { loading, data, height = 300, t } = this.props;

		return <BlockUi blocking={loading}>

			<ResponsiveContainer height={chartUtils.pieContainerHeight(data, height)}>
				<PieChart>
					<Pie data={data}
						dataKey='count' nameKey='name'
						innerRadius={60}
						outerRadius={80}
						fill='#8884d8'>
						{
							data && data.map((entry, index) => <Cell key={index} fill={COLORS[index % COLORS.length]} />)
						}
					</Pie>
					<Tooltip />
					<Legend align='center' verticalAlign='bottom' layout='vertical' formatter={chartUtils.formatPieLegendItem} />
				</PieChart>
			</ResponsiveContainer>
		</BlockUi>;
	}
}

export default withTranslation()(LessonPaymentsByPaymentMethod);